import React from "react";
import styles from "./Footer.module.css";

const Footer = () => {
  return (
    <div className={styles.wrapper}>
      <p>&copy;2018 Jessee Read & Howard, P.C. All rights reserved.</p>
    </div>
  );
};

export default Footer;
